import { render, staticRenderFns } from "./useDetails.vue?vue&type=template&id=5eab67e5&scoped=true&"
import script from "./useDetails.vue?vue&type=script&lang=ts&"
export * from "./useDetails.vue?vue&type=script&lang=ts&"
import style0 from "./useDetails.vue?vue&type=style&index=0&id=5eab67e5&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eab67e5",
  null
  
)

export default component.exports